<div class="thread-comments">
  @if (commentCount > 0) {
    <div class="thread-comments-count-header">
      @if (commentCount === 1) {
        {{ 'EDITOR.TRACK_CHANGES.SIDEBAR.COMMENT_COUNT_HEADER_ONE' | translate }}
      } @else {
        {{ 'EDITOR.TRACK_CHANGES.SIDEBAR.COMMENT_COUNT_HEADER_OTHER' | translate: { count: commentCount } }}
      }
    </div>
    <div class="thread-comments-list" #commentList>
      @for (comment of comments; track comment.id) {
        <div class="thread-comment">
          <div class="thread-comment-header">
            @if (comment.createdAtRelative !== null) {
              <span class="thread-comment-time">{{ comment.createdAtRelative }}</span>
            }
            <div class="thread-comment-author-info">
              <app-avatar [input]="comment.userName" size="small" class="thread-comment-avatar"></app-avatar>
              <span class="thread-comment-author-name">{{ comment.userName }}</span>
            </div>
          </div>
          <div class="thread-comment-body">{{ comment.body }}</div>
        </div>
      }
    </div>
  }
  <div class="thread-comments-reply">
    <app-avatar [input]="currentUser.name" size="small" class="thread-comments-reply-avatar"></app-avatar>
    <textarea
      class="thread-comments-reply-input"
      rows="1"
      [placeholder]="'EDITOR.TRACK_CHANGES.SIDEBAR.REPLY_PLACEHOLDER' | translate"
      [disabled]="!canPostComment"
      [(ngModel)]="draft"
      (keydown)="onKeyDown($event)"
    ></textarea>
  </div>
  @if (draft.length > 0) {
    <div class="thread-comments-reply-actions">
      <button type="button" class="thread-comments-reply-action thread-comments-reply-action-cancel" (click)="cancel()">
        {{ 'EDITOR.TRACK_CHANGES.SIDEBAR.ACTION_CANCEL' | translate }}
      </button>
      <button type="button" class="thread-comments-reply-action thread-comments-reply-action-submit" [disabled]="!canPostComment" (click)="submit()">
        {{ 'EDITOR.TRACK_CHANGES.SIDEBAR.ACTION_REPLY' | translate }}
      </button>
    </div>
  }
</div>
